import { useEffect, useMemo, useState } from "react";
import { useSite, useSeo } from "@/context/SiteContext";
import { api, photoSeason, sortBySeason } from "@/lib/api";
import { Section, PageHero, Lightbox, Empty } from "@/components/public/Shared";
import { useT } from "@/i18n";

export default function Gallery() {
  const t = useT();
  const { apartments, content } = useSite();
  const [media, setMedia] = useState([]);
  const [filter, setFilter] = useState("all");
  const [lb, setLb] = useState(null);
  useSeo();
  // Priorité d'affichage : photos de la saison en cours (hiver sept→mars, été avr→août) en premier
  useEffect(() => { api.get("/public/media").then((r) => setMedia(sortBySeason(r.data))).catch(() => {}); }, []);
  const filters = useMemo(() => [
    { key: "all", label: t("Tout"), testId: "gallery-filter-all" }, { key: "chalet", label: t("Le chalet"), testId: "gallery-filter-chalet" },
    ...apartments.filter((a) => media.some((m) => m.category === `apartment:${a.id}`)).map((a) => ({ key: `apartment:${a.id}`, label: a.name, testId: `gallery-filter-${a.slug}` })),
    { key: "ete", label: t("Été"), testId: "gallery-filter-summer" }, { key: "hiver", label: t("Hiver"), testId: "gallery-filter-winter" }, { key: "queyras", label: t("Le Queyras"), testId: "gallery-filter-queyras" },
  ], [apartments, media, t]);
  const items = filter === "all" ? media
    : filter === "ete" ? media.filter((m) => photoSeason(m) === "été")
    : filter === "hiver" ? media.filter((m) => photoSeason(m) === "hiver")
    : media.filter((m) => m.category === filter);
  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow={t("Galerie")} title={content.gallery_section?.title || t("Le chalet en images")} text={t("Le chalet, les appartements et le Queyras au fil des saisons.")} image={content.hero?.image_url} testId="gallery-hero" />
      <Section className="bg-ecru">
        <div className="flex flex-wrap gap-2" role="group" aria-label={t("Filtrer la galerie")}>
          {filters.map((f) => <button key={f.key} data-testid={f.testId} onClick={() => setFilter(f.key)} className={`px-4 py-2.5 rounded-full text-xs font-medium border transition-colors ${filter === f.key ? "bg-forest text-ecru border-forest" : "bg-white text-forest border-sand hover:border-forest"}`}>{f.label}</button>)}
        </div>
        {items.length ? (
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 mt-10 [&>*]:mb-4" data-testid="gallery-grid">
            {items.map((m, i) => (
              <button key={m.id} onClick={() => setLb(i)} className="block w-full overflow-hidden rounded-2xl bg-sand break-inside-avoid group" aria-label={`Agrandir : ${m.title || m.alt || t("photo")}`} data-testid={`gallery-item-${m.id}`}>
                <img src={m.url} alt={m.alt || m.title || ""} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              </button>
            ))}
          </div>
        ) : <div className="mt-10"><Empty testId="gallery-empty">{t("Aucune photo dans cette catégorie pour le moment.")}</Empty></div>}
        <Lightbox items={items} index={lb} onClose={() => setLb(null)} onIndex={setLb} />
      </Section>
    </div>
  );
}
